import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { AddressFields, Section } from 'modules/client/common/components';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/companyResidentialAddressForm';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  title?: string;
}

export const CompanyRegistrationAndResidentialAddressSection = ({
  countriesLoading,
  countries,
  title,
}: Props) => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  return (
    <Section
      datax="companyRegistrationAndResidentialAddressSection"
      title={
        title ??
        t('client.legal.companyRegistrationAndResidentialAddress.title')
      }
    >
      <Typography variant="bodyBold">
        {t('client.legal.companyRegistrationAddress.titleRegistration')}
      </Typography>
      <AddressFields
        countries={countries}
        countriesLoading={countriesLoading}
        variant="companyRegistrationAddress"
      />

      <Stack alignItems="center" direction="row" spacing={12}>
        <Typography variant="bodyBold">
          {t('client.legal.companyRegistrationAddress.titleResidential')}
        </Typography>
        <Stack alignItems="center" direction="row" flexWrap="wrap" spacing={8}>
          <Typography variant="caption">
            {t(
              'client.legal.companyRegistrationAndResidentialAddress.residencelabel'
            )}
          </Typography>
          <Field.Switch name="companyResidentialAddress.residentialAddressIsSame" />
        </Stack>
      </Stack>
      {!values.companyResidentialAddress.residentialAddressIsSame && (
        <AddressFields
          countries={countries}
          countriesLoading={countriesLoading}
          variant="companyResidentialAddress"
        />
      )}
    </Section>
  );
};
